var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align_left",
    "data-name": "align left",
    transform: "translate(-2552.604 -100.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    x2: 10,
    transform: "translate(2553.604 101.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    x2: 10,
    transform: "translate(2553.604 109.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    x2: 7,
    transform: "translate(2556.604 105.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    x2: 7,
    transform: "translate(2556.604 113.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignleft);
export default __webpack_public_path__ + "static/media/align left.f7a9e5e7b16783a04394896585d06f28.svg";
export { ForwardRef as ReactComponent };